<template>
  <section class="member-demo-module featured-lists">
    <div container>
      <div
        v-if="section.title || section.content"
        class="intro-content">
        <h2
          v-if="section.title"
          :style="globalTheme.color"
          class="section-header h2"
        >
          {{ section.title }}
        </h2>
        <div
          v-if="section.content"
          class="copy-wrap">
          <rich-text :html="section.content"></rich-text>
        </div>

        <list-columns
          v-if="section.listColumn.length"
          :list-columns="section.listColumn"/>

        <div
          v-if="section.contentBelow"
          class="copy-wrap">
          <rich-text :html="section.contentBelow"></rich-text>
        </div>
      </div>
      <div
        v-if="section.buttonLink && section.buttonLink.href"
        class="cta-wrap center-cta _mtm">
        <app-button-link
          :button="section.buttonLink"
          :style="globalTheme.button"
        />
      </div>
    </div>
  </section>
</template>

<script lang="ts">
  import { defineComponent } from 'vue'
  import { Boilerplate } from '@/types'
  import ListColumns from './FeaturedLists/ListColumns.vue'
  export default defineComponent({
    name: 'Featured-lists',
    components: { ListColumns },
    props: {
      section: {
        required: true,
        type: Object as () => Boilerplate
      }
    },
    provide() {
      return {
        colorOptions: this.section.colorOptions
      }
    }
  })
</script>
